export default __webpack_public_path__ + "static/media/lessa.8d39cc35.jpg";